import {
  AbstractList3ck35puwbp1e9 as AbstractList,
  Companion_instance2ztfx9zvq7j5d as Companion_instance,
} from '../collections/AbstractList.mjs';
import { getOrNull1d60i0672n7ns as getOrNull } from '../collections/_Arrays.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../Enum.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../hacks.mjs';
import { KtList3hktaavzmj137 as KtList } from '../collections/Collections.mjs';
import { RandomAccess1jbw8sdogqb8x as RandomAccess } from '../collections/RandomAccess.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var EnumEntriesListClass;
function EnumEntriesList() {
  if (EnumEntriesListClass === VOID) {
    class $ extends AbstractList() {
      constructor(entries) {
        return new.target.new_kotlin_enums_EnumEntriesList_dxc840_k$(entries);
      }
      static new_kotlin_enums_EnumEntriesList_dxc840_k$(entries) {
        var $this = this.new_kotlin_collections_AbstractList_7zpyyf_k$();
        $this.entries_1 = entries;
        return $this;
      }
      get_size_woubt6_k$() {
        return this.entries_1.length;
      }
      get_c1px32_k$(index) {
        Companion_instance.checkElementIndex_s0yg86_k$(index, this.entries_1.length);
        return this.entries_1[index];
      }
      contains_qvgeh3_k$(element) {
        if (element === null)
          return false;
        var target = getOrNull(this.entries_1, element.ordinal_1);
        return target === element;
      }
      contains_aljjnj_k$(element) {
        if (!(element instanceof Enum()))
          return false;
        return this.contains_qvgeh3_k$(element instanceof Enum() ? element : THROW_CCE());
      }
      indexOf_cbd19f_k$(element) {
        if (element === null)
          return -1;
        var ordinal = element.ordinal_1;
        var target = getOrNull(this.entries_1, ordinal);
        return target === element ? ordinal : -1;
      }
      indexOf_si1fv9_k$(element) {
        if (!(element instanceof Enum()))
          return -1;
        return this.indexOf_cbd19f_k$(element instanceof Enum() ? element : THROW_CCE());
      }
    }
    initMetadataForClass($, 'EnumEntriesList', VOID, VOID, [KtList(), RandomAccess()]);
    EnumEntriesListClass = $;
  }
  return EnumEntriesListClass;
}
function enumEntries(entries) {
  return EnumEntriesList().new_kotlin_enums_EnumEntriesList_dxc840_k$(entries);
}
//region block: exports
export {
  enumEntries as enumEntries20mr21zbe3az4,
};
//endregion

//# sourceMappingURL=EnumEntries.mjs.map
